import React from "react";
import Navbar from "../components/NavBar/Navbar";

import Hero from "../components/Hero/Hero";
import Values from "../components/Values/Values";
import About from "../components/About/About";
import Services from "../components/Services/Services";
import Realizations from "../components/Realizations/Realizations";
import Testimonials from "../components/Testimonials/Testimonials";
import Team from "../components/Team/Team";
import Contacts from "../components/Contacts/Contacts";
import Footer from "../components/Footer/Footer";
import { HomeContainer } from "./Home.styles";

function Home() {
  return (
    <div className="Home">
      <Navbar />
      <HomeContainer>
      <Hero />
      <Values />
      </HomeContainer>
      <About />
      <Services />
      <Realizations />
      <Testimonials />
      <Team />
      <Contacts />
      <Footer />

    </div>
  );
}

export default Home;